import { ComponentType } from 'react';
import { I18nextProvider } from 'react-i18next';
import { ErrorBoundaryProvider } from './ErrorBoundaryProvider';
import i18n from '../i18n';

const withProviders = <P extends { [key: string]: unknown }>(Component: ComponentType<P>) => {
	const WrappedComponent = (props: P) => {
		const queryParams = new URLSearchParams(window.location.search);
		const lang = queryParams.get('language');

		if (lang && i18n.language !== lang) {
			i18n.changeLanguage(lang).catch((err: unknown) => {
				console.error('Error changing language:', err);
			});
		}

		return (
			<ErrorBoundaryProvider>
				<I18nextProvider i18n={i18n}>
					<Component {...props} />
				</I18nextProvider>
			</ErrorBoundaryProvider>
		);
	};

	WrappedComponent.displayName = `WithProviders(${Component.displayName || Component.name || 'Component'})`;

	return WrappedComponent;
};

export { withProviders };
